import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Portal } from '@klarna/mp-ui';
import { FeatureTourOverlay } from '../common/FeatureTour';
import { Popover } from './Popover';
export default function PopOverWithHighlight({ children, showPopOver, popOverOnClose, componentRef, padding, position, radius }) {
    return (_jsxs(Portal, { children: [showPopOver && (_jsx(FeatureTourOverlay, { componentRef: componentRef, onClick: popOverOnClose, padding: padding, radius: radius })), showPopOver && (_jsx(Popover, { componentRef: componentRef, onClose: popOverOnClose, padding: padding, position: position, children: children }))] }));
}
